import { Settings as ProSettings } from '@ant-design/pro-layout';

type DefaultSettings = Partial<ProSettings> & {
  pwa: boolean;
};

const proSettings: DefaultSettings = {
  navTheme: 'dark',
  // 拂晓蓝
  // primaryColor: '#1890ff',
  // 蜗牛绿
  primaryColor: '#17C3D2',
  layout: 'side',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: 'BB8',
  pwa: false,
  iconfontUrl: '',
  menu: {
    locale: false,
  },
};

export type { DefaultSettings };

export default proSettings;
